module.exports = __webpack_public_path__ + "img/overSpeed.4d093475.svg";